import React from 'react';

import {
  Stack,
  GroupIcon,
  Typography,
  Divider,
  SettingsIcon,
  NotificationsIcon,
} from '@gogame/components';
import { ScreenLink } from '@gogame/screens';

import { smartRulesDetailsLink } from 'scenes/SmartRules/navigation';
import { useSchedule } from 'scenes/SmartRules/hooks';

const Name = ({ row, value }) => {
  const entityProps = [
    row?.target?.networks?.map(({ name }) => name).join(', '),
    row?.target?.applications?.map(({ name }) => name).join(', '),
    row?.target?.platforms?.map(({ name }) => name).join(', '),
    row?.target?.affiliates?.map(({ name }) => name).join(', '),
  ]
    .filter((i) => i)
    .join(' / ');

  const schedule = useSchedule({ data: row });

  return (
    <Stack
      direction={'row'}
      spacing={2}
      alignItems={'center'}
      zeroMinWidth={true}
    >
      {row.action ? (
        <SettingsIcon fontSize={'small'} color={'action'} />
      ) : (
        <NotificationsIcon fontSize={'small'} color={'action'} />
      )}
      <Stack spacing={0.5} zeroMinWidth={true}>
        <Stack
          spacing={1}
          direction={'row'}
          alignItems={'center'}
          zeroMinWidth={true}
        >
          <Typography noWrap tooltipText={value} variant={'body2'}>
            <ScreenLink
              link={smartRulesDetailsLink}
              pathParams={{
                id: row.id,
              }}
            >
              {value}
            </ScreenLink>
          </Typography>
          <GroupIcon fontSize={'small'} color={'action'} />
        </Stack>
        {entityProps ? (
          <Typography variant={'caption'} noWrap>
            {entityProps}
          </Typography>
        ) : null}
        <Stack direction={'row'} spacing={1}>
          <Typography variant={'overline'} whiteSpace={'normal'}>
            {row.action
              ? row.action.skip
                ? 'Auto-modifying'
                : 'Modifying'
              : 'Notifying'}
          </Typography>
          <Divider orientation={'vertical'} flexItem />
          <Typography variant={'overline'} whiteSpace={'normal'}>
            {schedule}
          </Typography>
          <Divider orientation={'vertical'} flexItem />
          <Typography variant={'overline'} whiteSpace={'normal'}>
            {row.trackerPeriod.name}
          </Typography>
          {row.isDynamic ? (
            <React.Fragment>
              <Divider orientation={'vertical'} flexItem />
              <Typography variant={'overline'} whiteSpace={'normal'}>
                Dynamic Conditions
              </Typography>
            </React.Fragment>
          ) : null}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Name;
